import { render, staticRenderFns } from "./advanced_rubric_preview_table.vue?vue&type=template&id=186b8380&scoped=true&"
import script from "./advanced_rubric_preview_table.vue?vue&type=script&lang=js&"
export * from "./advanced_rubric_preview_table.vue?vue&type=script&lang=js&"
import style0 from "./advanced_rubric_preview_table.vue?vue&type=style&index=0&id=186b8380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186b8380",
  null
  
)

export default component.exports